// extracted by mini-css-extract-plugin
export var details = "_gs-0";
export var inspectorPopover = "_gs-1";